import { shallow } from 'zustand/shallow';

import { CAR_PURCHASE_STATUS } from '@/constants/constants';
import { useUpdatedCarStatus } from '@/plp/components/Results/useUpdatedCarStatus';
import { authStore } from '@/stores/authStore';
import { cartStore } from '@/stores/cartStore';

import { PillPurchaseStatuses } from './StatusPill.type';

interface Props {
  sku: string;
  state: CAR_PURCHASE_STATUS;
}

export const useStatusPillState = ({ sku, state }: Props) => {
  const carStatus = useUpdatedCarStatus(sku, state);

  const { userOrders } = authStore(
    (state) => ({
      userOrders: state.userOrders,
    }),
    shallow,
  );

  const { carData, cartExpired } = cartStore(
    (state) => ({
      carData: state.carData,
      cartExpired: state.cartExpired,
    }),
    shallow,
  );

  let status: PillPurchaseStatuses | 'myPurchase' | undefined = undefined;

  if (carStatus === 'draftOrder') {
    status = 'draftOrder';
  } else if (carStatus === 'purchased') {
    status = 'purchased';
  } else if (carStatus === 'reserved' || carStatus === 'delivered') {
    status = 'reserved';
  }

  if ((carData?.sku === sku && !cartExpired) || userOrders.find((item) => item.vehicle.sku === sku)) {
    status = 'myPurchase';
  }

  return { status };
};
